// Idiomas para datalayers de GTM
export const arrayLangKeys: Record<string, string> = {
  es: 'spa',
  en: 'eng',
	de: 'deu',
	fr: 'fra',
	it: 'ita'
}

// Códigos de países
export const countryLangCodes = {
  es: 'ES',
  en: 'GB',
  de: 'DE',
  fr: 'FR',
  it: 'IT'
}

// LATAM country ids
export const latamCountries = [
  'AR', 'BO', 'BR', 'CL', 'CO', 'CR', 'CU', 'DO', 'EC', 'SV', 'GT', 'HN', 
  'MX', 'NI', 'PA', 'PY', 'PE', 'PR', 'UY', 'VE'
]

// Default destinations for SearchInput
export const defaultDestinations: Record<string, Destination[]> = {
  es: [
    {
      id: 456683,
      label: "Bogotá",
      suffix: "Colombia",
      icon: "i-heroicons-map-pin-solid",
      category_id: 2,
      element_id: 456683,
      location: "4.6097,-74.0818",
      search_distance: 50,
      locale: "es",
      country_id: "CO",
      url: "/es/bogota-456683d.html",
      order_ratio: 121,
      name_general: "Bogotá",
      name_translated: "Bogotá",
      country_name_general: "Colombia",
      country_name_translated: "Colombia",
      timezone: "America/Bogota",
      num_hotels: 121,
      hierarchy_id: 5,
      type: "destination"
    },
    {
      id: 28988,
      label: "Madrid",
      suffix: "España",
      icon: "i-heroicons-map-pin-solid",
      category_id: 2,
      element_id: 28988,
      location: "40.4165,-3.7026",
      search_distance: 20,
      locale: "es",
      country_id: "ES",
      url: "/es/madrid-28988d.html",
      order_ratio: 76,
      name_general: "Madrid",
      name_translated: "Madrid",
      country_name_general: "España",
      country_name_translated: "España",
      timezone: "Europe/Madrid",
      num_hotels: 76,
      hierarchy_id: 5,
      type: "destination"
    },
    {
      id: 9292,
      label: "Barcelona",
      suffix: "España",
      icon: "i-heroicons-map-pin-solid",
      category_id: 2,
      element_id: 9292,
      location: "41.3888,2.1590",
      search_distance: 20,
      locale: "es",
      country_id: "ES",
      url: "/es/barcelona-9292d.html",
      order_ratio: 82,
      name_general: "Barcelona",
      name_translated: "Barcelona",
      country_name_general: "España",
      country_name_translated: "España",
      timezone: "Europe/Madrid",
      num_hotels: 82,
      hierarchy_id: 5,
      type: "destination"
    },
    {
      id: 1097817,
      label: "Lima",
      suffix: "Perú",
      icon: "i-heroicons-map-pin-solid",
      category_id: 2,
      element_id: 1097817,
      location: "-12.0432,-77.0282",
      search_distance: 10,
      locale: "es",
      country_id: "PE",
      url: "/es/lima-1097817d.html",
      order_ratio: 47,
      name_general: "Lima",
      name_translated: "Lima",
      country_name_general: "Peru",
      country_name_translated: "Perú",
      timezone: "America/Lima",
      num_hotels: 47,
      hierarchy_id: 5,
      type: "destination"
    },
    {
      id: 935331,
      label: "Ciudad de Panamá",
      suffix: "Panamá",
      icon: "i-heroicons-map-pin-solid",
      category_id: 2,
      element_id: 935331,
      location: "8.9936,-79.5197",
      search_distance: 20,
      locale: "es",
      country_id: "PA",
      url: "/es/ciudadpanama-935331d.html",
      order_ratio: 24,
      name_general: "Panamá",
      name_translated: "Ciudad de Panamá",
      country_name_general: "Panama",
      country_name_translated: "Panamá",
      timezone: "America/Panama",
      num_hotels: 24,
      hierarchy_id: 5,
      type: "destination"
    },
    {
      id: 799154,
      label: "Ciudad de México",
      suffix: "México",
      icon: "i-heroicons-map-pin-solid",
      category_id: 2,
      element_id: 799154,
      location: "19.4285,-99.1277",
      search_distance: 30,
      locale: "es",
      country_id: "MX",
      url: "/es/mexico-city-799154d.html",
      order_ratio: 30,
      name_general: "Mexico City",
      name_translated: "Ciudad de México",
      country_name_general: "Mexico",
      country_name_translated: "México",
      timezone: "America/Mexico_City",
      num_hotels: 30,
      hierarchy_id: 5,
      type: "destination"
    },
    {
      id: 648357,
      label: "Buenos Aires",
      suffix: "Argentina",
      icon: "i-heroicons-map-pin-solid",
      category_id: 2,
      element_id: 648357,
      location: "-34.6132,-58.3772",
      search_distance: 30,
      locale: "es",
      country_id: "AR",
      url: "/es/buenos-aires-648357d.html",
      order_ratio: 35,
      name_general: "Buenos Aires",
      name_translated: "Buenos Aires",
      country_name_general: "Argentine",
      country_name_translated: "Argentina",
      timezone: "America/Argentina/Buenos_Aires",
      num_hotels: 35,
      hierarchy_id: 5,
      type: "destination"
    },
    {
      id: 459240,
      label: "Barranquilla",
      suffix: "Colombia",
      icon: "i-heroicons-map-pin-solid",
      category_id: 2,
      element_id: 459240,
      location: "10.9685,-74.7813",
      search_distance: 10,
      locale: "es",
      country_id: "CO",
      url: "/es/barranquilla-459240d.html",
      order_ratio: 16,
      name_general: "Barranquilla",
      name_translated: "Barranquilla",
      country_name_general: "Colombia",
      country_name_translated: "Colombia",
      timezone: "America/Bogota",
      num_hotels: 16,
      hierarchy_id: 5,
      type: "destination"
    },
    {
      id: 29719,
      label: "Berlín",
      suffix: "Alemania",
      icon: "i-heroicons-map-pin-solid",
      category_id: 2,
      element_id: 29719,
      location: "52.5244,13.4105",
      search_distance: 69,
      locale: "es",
      country_id: "DE",
      url: "/es/berlin-29719d.html",
      order_ratio: 12,
      name_general: "Berlin",
      name_translated: "Berlín",
      country_name_general: "Germany",
      country_name_translated: "Alemania",
      timezone: "Europe/Berlin",
      num_hotels: 12,
      hierarchy_id: 5,
      type: "destination"
    }
  ],
  en: [
    {
      id: 456683,
      label: "Bogota",
      suffix: "Colombia",
      icon: "i-heroicons-map-pin-solid",
      category_id: 2,
      element_id: 456683,
      location: "4.6097,-74.0818",
      search_distance: 50,
      locale: "en",
      country_id: "CO",
      url: "/en/bogota-456683d.html",
      order_ratio: 121,
      name_general: "Bogota",
      name_translated: "Bogota",
      country_name_general: "Colombia",
      country_name_translated: "Colombia",
      timezone: "America/Bogota",
      num_hotels: 121,
      hierarchy_id: 5,
      type: "destination"
    },
    {
      id: 28988,
      label: "Madrid",
      suffix: "Spain",
      icon: "i-heroicons-map-pin-solid",
      category_id: 2,
      element_id: 28988,
      location: "40.4165,-3.7026",
      search_distance: 20,
      locale: "en",
      country_id: "ES",
      url: "/en/madrid-28988d.html",
      order_ratio: 76,
      name_general: "Madrid",
      name_translated: "Madrid",
      country_name_general: "Spain",
      country_name_translated: "Spain",
      timezone: "Europe/Madrid",
      num_hotels: 76,
      hierarchy_id: 5,
      type: "destination"
    },
    {
      id: 9292,
      label: "Barcelona",
      suffix: "Spain",
      icon: "i-heroicons-map-pin-solid",
      category_id: 2,
      element_id: 9292,
      location: "41.3888,2.1590",
      search_distance: 20,
      locale: "en",
      country_id: "ES",
      url: "/en/barcelona-9292d.html",
      order_ratio: 82,
      name_general: "Barcelona",
      name_translated: "Barcelona",
      country_name_general: "Spain",
      country_name_translated: "Spain",
      timezone: "Europe/Madrid",
      num_hotels: 82,
      hierarchy_id: 5,
      type: "destination"
    },
    {
      id: 1097817,
      label: "Lima",
      suffix: "Peru",
      icon: "i-heroicons-map-pin-solid",
      category_id: 2,
      element_id: 1097817,
      location: "-12.0432,-77.0282",
      search_distance: 10,
      locale: "en",
      country_id: "PE",
      url: "/en/lima-1097817d.html",
      order_ratio: 47,
      name_general: "Lima",
      name_translated: "Lima",
      country_name_general: "Peru",
      country_name_translated: "Peru",
      timezone: "America/Lima",
      num_hotels: 47,
      hierarchy_id: 5,
      type: "destination"
    },
    {
      id: 935331,
      label: "Panama City",
      suffix: "Panama",
      icon: "i-heroicons-map-pin-solid",
      category_id: 2,
      element_id: 935331,
      location: "8.9936,-79.5197",
      search_distance: 20,
      locale: "en",
      country_id: "PA",
      url: "/en/panama-city-935331d.html",
      order_ratio: 24,
      name_general: "Panama",
      name_translated: "Panama City",
      country_name_general: "Panama",
      country_name_translated: "Panama",
      timezone: "America/Panama",
      num_hotels: 24,
      hierarchy_id: 5,
      type: "destination"
    },
    {
      id: 799154,
      label: "Mexico City",
      suffix: "Mexico",
      icon: "i-heroicons-map-pin-solid",
      category_id: 2,
      element_id: 799154,
      location: "19.4285,-99.1277",
      search_distance: 30,
      locale: "en",
      country_id: "MX",
      url: "/en/mexico-city-799154d.html",
      order_ratio: 30,
      name_general: "Mexico City",
      name_translated: "Mexico City",
      country_name_general: "Mexico",
      country_name_translated: "Mexico",
      timezone: "America/Mexico_City",
      num_hotels: 30,
      hierarchy_id: 5,
      type: "destination"
    },
    {
      id: 648357,
      label: "Buenos Aires",
      suffix: "Argentina",
      icon: "i-heroicons-map-pin-solid",
      category_id: 2,
      element_id: 648357,
      location: "-34.6132,-58.3772",
      search_distance: 30,
      locale: "en",
      country_id: "AR",
      url: "/en/buenos-aires-648357d.html",
      order_ratio: 35,
      name_general: "Buenos Aires",
      name_translated: "Buenos Aires",
      country_name_general: "Argentina",
      country_name_translated: "Argentina",
      timezone: "America/Argentina/Buenos_Aires",
      num_hotels: 35,
      hierarchy_id: 5,
      type: "destination"
    },
    {
      id: 459240,
      label: "Barranquilla",
      suffix: "Colombia",
      icon: "i-heroicons-map-pin-solid",
      category_id: 2,
      element_id: 459240,
      location: "10.9685,-74.7813",
      search_distance: 10,
      locale: "en",
      country_id: "CO",
      url: "/en/barranquilla-459240d.html",
      order_ratio: 16,
      name_general: "Barranquilla",
      name_translated: "Barranquilla",
      country_name_general: "Colombia",
      country_name_translated: "Colombia",
      timezone: "America/Bogota",
      num_hotels: 16,
      hierarchy_id: 5,
      type: "destination"
    },
    {
      id: 29719,
      label: "Berlin",
      suffix: "Germany",
      icon: "i-heroicons-map-pin-solid",
      category_id: 2,
      element_id: 29719,
      location: "52.5244,13.4105",
      search_distance: 69,
      locale: "en",
      country_id: "DE",
      url: "/en/berlin-29719d.html",
      order_ratio: 12,
      name_general: "Berlin",
      name_translated: "Berlin",
      country_name_general: "Germany",
      country_name_translated: "Germany",
      timezone: "Europe/Berlin",
      num_hotels: 12,
      hierarchy_id: 5,
      type: "destination"
    }
  ],
  de: [
    {
      id: 456683,
      label: "Bogota",
      suffix: "Kolumbien",
      icon: "i-heroicons-map-pin-solid",
      category_id: 2,
      element_id: 456683,
      location: "4.6097,-74.0818",
      search_distance: 50,
      locale: "de",
      country_id: "CO",
      url: "/de/bogota-456683d.html",
      order_ratio: 121,
      name_general: "Bogota",
      name_translated: "Bogota",
      country_name_general: "Kolumbien",
      country_name_translated: "Kolumbien",
      timezone: "America/Bogota",
      num_hotels: 121,
      hierarchy_id: 5,
      type: "destination"
    },
    {
      id: 28988,
      label: "Madrid",
      suffix: "Spanien",
      icon: "i-heroicons-map-pin-solid",
      category_id: 2,
      element_id: 28988,
      location: "40.4165,-3.7026",
      search_distance: 20,
      locale: "de",
      country_id: "ES",
      url: "/de/madrid-28988d.html",
      order_ratio: 76,
      name_general: "Madrid",
      name_translated: "Madrid",
      country_name_general: "Spanien",
      country_name_translated: "Spanien",
      timezone: "Europe/Madrid",
      num_hotels: 76,
      hierarchy_id: 5,
      type: "destination"
    },
    {
      id: 9292,
      label: "Barcelona",
      suffix: "Spanien",
      icon: "i-heroicons-map-pin-solid",
      category_id: 2,
      element_id: 9292,
      location: "41.3888,2.1590",
      search_distance: 20,
      locale: "de",
      country_id: "ES",
      url: "/de/barcelona-9292d.html",
      order_ratio: 82,
      name_general: "Barcelona",
      name_translated: "Barcelona",
      country_name_general: "Spanien",
      country_name_translated: "Spanien",
      timezone: "Europe/Madrid",
      num_hotels: 82,
      hierarchy_id: 5,
      type: "destination"
    },
    {
      id: 1097817,
      label: "Lima",
      suffix: "Peru",
      icon: "i-heroicons-map-pin-solid",
      category_id: 2,
      element_id: 1097817,
      location: "-12.0432,-77.0282",
      search_distance: 10,
      locale: "de",
      country_id: "PE",
      url: "/de/lima-1097817d.html",
      order_ratio: 47,
      name_general: "Lima",
      name_translated: "Lima",
      country_name_general: "Peru",
      country_name_translated: "Peru",
      timezone: "America/Lima",
      num_hotels: 47,
      hierarchy_id: 5,
      type: "destination"
    },
    {
      id: 935331,
      label: "Panama Stadt",
      suffix: "Panama",
      icon: "i-heroicons-map-pin-solid",
      category_id: 2,
      element_id: 935331,
      location: "8.9936,-79.5197",
      search_distance: 20,
      locale: "de",
      country_id: "PA",
      url: "/de/panama-city-935331d.html",
      order_ratio: 24,
      name_general: "Panama",
      name_translated: "Panama Stadt",
      country_name_general: "Panama",
      country_name_translated: "Panama",
      timezone: "America/Panama",
      num_hotels: 24,
      hierarchy_id: 5,
      type: "destination"
    },
    {
      id: 799154,
      label: "Mexiko-Stadt",
      suffix: "Mexiko",
      icon: "i-heroicons-map-pin-solid",
      category_id: 2,
      element_id: 799154,
      location: "19.4285,-99.1277",
      search_distance: 30,
      locale: "de",
      country_id: "MX",
      url: "/de/mexico-city-799154d.html",
      order_ratio: 30,
      name_general: "Mexico City",
      name_translated: "Mexiko-Stadt",
      country_name_general: "Mexico",
      country_name_translated: "Mexiko",
      timezone: "America/Mexico_City",
      num_hotels: 30,
      hierarchy_id: 5,
      type: "destination"
    },
    {
      id: 648357,
      label: "Buenos Aires",
      suffix: "Argentinien",
      icon: "i-heroicons-map-pin-solid",
      category_id: 2,
      element_id: 648357,
      location: "-34.6132,-58.3772",
      search_distance: 30,
      locale: "de",
      country_id: "AR",
      url: "/de/buenos-aires-648357d.html",
      order_ratio: 35,
      name_general: "Buenos Aires",
      name_translated: "Buenos Aires",
      country_name_general: "Argentine",
      country_name_translated: "Argentinien",
      timezone: "America/Argentina/Buenos_Aires",
      num_hotels: 35,
      hierarchy_id: 5,
      type: "destination"
    },
    {
      id: 459240,
      label: "Barranquilla",
      suffix: "Kolumbien",
      icon: "i-heroicons-map-pin-solid",
      category_id: 2,
      element_id: 459240,
      location: "10.9685,-74.7813",
      search_distance: 10,
      locale: "de",
      country_id: "CO",
      url: "/de/barranquilla-459240d.html",
      order_ratio: 16,
      name_general: "Barranquilla",
      name_translated: "Barranquilla",
      country_name_general: "Kolumbien",
      country_name_translated: "Kolumbien",
      timezone: "America/Bogota",
      num_hotels: 16,
      hierarchy_id: 5,
      type: "destination"
    },
    {
      id: 29719,
      label: "Berlin",
      suffix: "Deutschland",
      icon: "i-heroicons-map-pin-solid",
      category_id: 2,
      element_id: 29719,
      location: "52.5244,13.4105",
      search_distance: 69,
      locale: "de",
      country_id: "DE",
      url: "/de/berlin-29719d.html",
      order_ratio: 12,
      name_general: "Berlin",
      name_translated: "Berlin",
      country_name_general: "Germany",
      country_name_translated: "Deutschland",
      timezone: "Europe/Berlin",
      num_hotels: 12,
      hierarchy_id: 5,
      type: "destination"
    }
  ],
  fr: [
    {
      id: 456683,
      label: "Bogota",
      suffix: "Colombie",
      icon: "i-heroicons-map-pin-solid",
      category_id: 2,
      element_id: 456683,
      location: "4.6097,-74.0818",
      search_distance: 50,
      locale: "fr",
      country_id: "CO",
      url: "/fr/bogota-456683d.html",
      order_ratio: 121,
      name_general: "Bogota",
      name_translated: "Bogota",
      country_name_general: "Colombie",
      country_name_translated: "Colombie",
      timezone: "America/Bogota",
      num_hotels: 121,
      hierarchy_id: 5,
      type: "destination"
    },
    {
      id: 28988,
      label: "Madrid",
      suffix: "Espagne",
      icon: "i-heroicons-map-pin-solid",
      category_id: 2,
      element_id: 28988,
      location: "40.4165,-3.7026",
      search_distance: 20,
      locale: "fr",
      country_id: "ES",
      url: "/fr/madrid-28988d.html",
      order_ratio: 76,
      name_general: "Madrid",
      name_translated: "Madrid",
      country_name_general: "Espagne",
      country_name_translated: "Espagne",
      timezone: "Europe/Madrid",
      num_hotels: 76,
      hierarchy_id: 5,
      type: "destination"
    },
    {
      id: 9292,
      label: "Barcelona",
      suffix: "Espagne",
      icon: "i-heroicons-map-pin-solid",
      category_id: 2,
      element_id: 9292,
      location: "41.3888,2.1590",
      search_distance: 20,
      locale: "fr",
      country_id: "ES",
      url: "/fr/barcelona-9292d.html",
      order_ratio: 82,
      name_general: "Barcelona",
      name_translated: "Barcelona",
      country_name_general: "Espagne",
      country_name_translated: "Espagne",
      timezone: "Europe/Madrid",
      num_hotels: 82,
      hierarchy_id: 5,
      type: "destination"
    },
    {
      id: 1097817,
      label: "Lima",
      suffix: "Pérou",
      icon: "i-heroicons-map-pin-solid",
      category_id: 2,
      element_id: 1097817,
      location: "-12.0432,-77.0282",
      search_distance: 10,
      locale: "fr",
      country_id: "PE",
      url: "/fr/lima-1097817d.html",
      order_ratio: 47,
      name_general: "Lima",
      name_translated: "Lima",
      country_name_general: "Pérou",
      country_name_translated: "Pérou",
      timezone: "America/Lima",
      num_hotels: 47,
      hierarchy_id: 5,
      type: "destination"
    },
    {
      id: 935331,
      label: "Ville de Panama",
      suffix: "Panama",
      icon: "i-heroicons-map-pin-solid",
      category_id: 2,
      element_id: 935331,
      location: "8.9936,-79.5197",
      search_distance: 20,
      locale: "fr",
      country_id: "PA",
      url: "/fr/panama-city-935331d.html",
      order_ratio: 24,
      name_general: "Panama",
      name_translated: "Ville de Panama",
      country_name_general: "Panama",
      country_name_translated: "Panama",
      timezone: "America/Panama",
      num_hotels: 24,
      hierarchy_id: 5,
      type: "destination"
    },
    {
      id: 799154,
      label: "Mexico City",
      suffix: "Mexique",
      icon: "i-heroicons-map-pin-solid",
      category_id: 2,
      element_id: 799154,
      location: "19.4285,-99.1277",
      search_distance: 30,
      locale: "fr",
      country_id: "MX",
      url: "/fr/mexico-city-799154d.html",
      order_ratio: 30,
      name_general: "Mexico City",
      name_translated: "Mexico City",
      country_name_general: "Mexique",
      country_name_translated: "Mexique",
      timezone: "America/Mexico_City",
      num_hotels: 30,
      hierarchy_id: 5,
      type: "destination"
    },
    {
      id: 648357,
      label: "Buenos Aires",
      suffix: "Argentine",
      icon: "i-heroicons-map-pin-solid",
      category_id: 2,
      element_id: 648357,
      location: "-34.6132,-58.3772",
      search_distance: 30,
      locale: "fr",
      country_id: "AR",
      url: "/fr/buenos-aires-648357d.html",
      order_ratio: 35,
      name_general: "Buenos Aires",
      name_translated: "Buenos Aires",
      country_name_general: "Argentine",
      country_name_translated: "Argentine",
      timezone: "America/Argentina/Buenos_Aires",
      num_hotels: 35,
      hierarchy_id: 5,
      type: "destination"
    },
    {
      id: 459240,
      label: "Barranquilla",
      suffix: "Colombie",
      icon: "i-heroicons-map-pin-solid",
      category_id: 2,
      element_id: 459240,
      location: "10.9685,-74.7813",
      search_distance: 10,
      locale: "fr",
      country_id: "CO",
      url: "/fr/barranquilla-459240d.html",
      order_ratio: 16,
      name_general: "Barranquilla",
      name_translated: "Barranquilla",
      country_name_general: "Colombie",
      country_name_translated: "Colombie",
      timezone: "America/Bogota",
      num_hotels: 16,
      hierarchy_id: 5,
      type: "destination"
    },
    {
      id: 29719,
      label: "Berlin",
      suffix: "Allemagne",
      icon: "i-heroicons-map-pin-solid",
      category_id: 2,
      element_id: 29719,
      location: "52.5244,13.4105",
      search_distance: 69,
      locale: "fr",
      country_id: "DE",
      url: "/fr/berlin-29719d.html",
      order_ratio: 12,
      name_general: "Berlin",
      name_translated: "Berlin",
      country_name_general: "Germany",
      country_name_translated: "Allemagne",
      timezone: "Europe/Berlin",
      num_hotels: 12,
      hierarchy_id: 5,
      type: "destination"
    }
  ],
  it: [
    {
      id: 456683,
      label: "Bogota",
      suffix: "Colombia",
      icon: "i-heroicons-map-pin-solid",
      category_id: 2,
      element_id: 456683,
      location: "4.6097,-74.0818",
      search_distance: 50,
      locale: "it",
      country_id: "CO",
      url: "/it/bogota-456683d.html",
      order_ratio: 121,
      name_general: "Bogota",
      name_translated: "Bogota",
      country_name_general: "Colombia",
      country_name_translated: "Colombia",
      timezone: "America/Bogota",
      num_hotels: 121,
      hierarchy_id: 5,
      type: "destination"
    },
    {
      id: 28988,
      label: "Madrid",
      suffix: "Spagna",
      icon: "i-heroicons-map-pin-solid",
      category_id: 2,
      element_id: 28988,
      location: "40.4165,-3.7026",
      search_distance: 20,
      locale: "it",
      country_id: "ES",
      url: "/it/madrid-28988d.html",
      order_ratio: 76,
      name_general: "Madrid",
      name_translated: "Madrid",
      country_name_general: "Spagna",
      country_name_translated: "Spagna",
      timezone: "Europe/Madrid",
      num_hotels: 76,
      hierarchy_id: 5,
      type: "destination"
    },
    {
      id: 9292,
      label: "Barcelona",
      suffix: "Spagna",
      icon: "i-heroicons-map-pin-solid",
      category_id: 2,
      element_id: 9292,
      location: "41.3888,2.1590",
      search_distance: 20,
      locale: "it",
      country_id: "ES",
      url: "/it/barcelona-9292d.html",
      order_ratio: 82,
      name_general: "Barcelona",
      name_translated: "Barcelona",
      country_name_general: "Spagna",
      country_name_translated: "Spagna",
      timezone: "Europe/Madrid",
      num_hotels: 82,
      hierarchy_id: 5,
      type: "destination"
    },
    {
      id: 1097817,
      label: "Lima",
      suffix: "Perù",
      icon: "i-heroicons-map-pin-solid",
      category_id: 2,
      element_id: 1097817,
      location: "-12.0432,-77.0282",
      search_distance: 10,
      locale: "it",
      country_id: "PE",
      url: "/it/lima-1097817d.html",
      order_ratio: 47,
      name_general: "Lima",
      name_translated: "Lima",
      country_name_general: "Peru",
      country_name_translated: "Perù",
      timezone: "America/Lima",
      num_hotels: 47,
      hierarchy_id: 5,
      type: "destination"
    },
    {
      id: 935331,
      label: "Città di Panama",
      suffix: "Panama",
      icon: "i-heroicons-map-pin-solid",
      category_id: 2,
      element_id: 935331,
      location: "8.9936,-79.5197",
      search_distance: 20,
      locale: "it",
      country_id: "PA",
      url: "/it/panama-city-935331d.html",
      order_ratio: 24,
      name_general: "Panama",
      name_translated: "Città di Panama",
      country_name_general: "Panama",
      country_name_translated: "Panama",
      timezone: "America/Panama",
      num_hotels: 24,
      hierarchy_id: 5,
      type: "destination"
    },
    {
      id: 799154,
      label: "Città del Messico",
      suffix: "Messico",
      icon: "i-heroicons-map-pin-solid",
      category_id: 2,
      element_id: 799154,
      location: "19.4285,-99.1277",
      search_distance: 30,
      locale: "it",
      country_id: "MX",
      url: "/it/mexico-city-799154d.html",
      order_ratio: 30,
      name_general: "Mexico City",
      name_translated: "Città del Messico",
      country_name_general: "Mexico",
      country_name_translated: "Messico",
      timezone: "America/Mexico_City",
      num_hotels: 30,
      hierarchy_id: 5,
      type: "destination"
    },
    {
      id: 648357,
      label: "Buenos Aires",
      suffix: "Argentina",
      icon: "i-heroicons-map-pin-solid",
      category_id: 2,
      element_id: 648357,
      location: "-34.6132,-58.3772",
      search_distance: 30,
      locale: "it",
      country_id: "AR",
      url: "/it/buenos-aires-648357d.html",
      order_ratio: 35,
      name_general: "Buenos Aires",
      name_translated: "Buenos Aires",
      country_name_general: "Argentina",
      country_name_translated: "Argentina",
      timezone: "America/Argentina/Buenos_Aires",
      num_hotels: 35,
      hierarchy_id: 5,
      type: "destination"
    },
    {
      id: 459240,
      label: "Barranquilla",
      suffix: "Colombia",
      icon: "i-heroicons-map-pin-solid",
      category_id: 2,
      element_id: 459240,
      location: "10.9685,-74.7813",
      search_distance: 10,
      locale: "it",
      country_id: "CO",
      url: "/it/barranquilla-459240d.html",
      order_ratio: 16,
      name_general: "Barranquilla",
      name_translated: "Barranquilla",
      country_name_general: "Colombia",
      country_name_translated: "Colombia",
      timezone: "America/Bogota",
      num_hotels: 16,
      hierarchy_id: 5,
      type: "destination"
    },
    {
      id: 29719,
      label: "Berlino",
      suffix: "Germania",
      icon: "i-heroicons-map-pin-solid",
      category_id: 2,
      element_id: 29719,
      location: "52.5244,13.4105",
      search_distance: 69,
      locale: "it",
      country_id: "DE",
      url: "/it/berlin-29719d.html",
      order_ratio: 12,
      name_general: "Berlin",
      name_translated: "Berlino",
      country_name_general: "Germany",
      country_name_translated: "Germania",
      timezone: "Europe/Berlin",
      num_hotels: 12,
      hierarchy_id: 5,
      type: "destination"
    }
  ]
};